module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n        Contrato " + _vm._s(_vm.contractId) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "min-content"
  }, [(_vm.contract) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box margin-t20"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("\n            " + _vm._s(_vm.contract.plan.name) + "\n            "), (!_vm.isPessoaJuridica()) ? _c('a', {
    staticClass: "label-link",
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
      "target": "_blank"
    }
  }, [_vm._v("Ver as\n              Condições Gerais de Contratação")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "info-box-left"
  }, [_c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Ativação do Contrato:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.contract.startDate)))])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Encerramento do Contrato:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.contract.endDate ? _vm.contract.endDate : '-'))])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Status do Contrato:")]), _vm._v(" "), _c('b', [_vm._v("\n                        " + _vm._s(_vm.contract.status.name) + "\n                        "), _c('span', {
    class: _vm.contract.status.name == 'ATIVO' ? 'status-active' : 'status-inactive'
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contract.plan.planId == 21 || _vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 31) ? _c('div', [(_vm.contract.plan.planId == 21 || _vm.contract.plan.planId == 31) ? _c('div', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Ativar Alerta de Saldo: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "onoffswitch",
    attrs: {
      "id": "ptoAlm1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.lcFlag),
      expression: "contract.lcFlag"
    }],
    staticClass: "onoffswitch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "round-switch"
    },
    domProps: {
      "checked": Array.isArray(_vm.contract.lcFlag) ? _vm._i(_vm.contract.lcFlag, null) > -1 : (_vm.contract.lcFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contract.lcFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contract, "lcFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contract, "lcFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contract, "lcFlag", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "inline form-control text-right",
    attrs: {
      "id": "limitValue",
      "minlength": "5",
      "maxlength": "10",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.valueFormatted()
    }
  })])]) : (_vm.contract.plan.planId == 28) ? _c('div', [_c('label', {
    staticClass: "label-detail-left"
  }, [_vm._v("Alterar percentual de alerta de consumo de limite:")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ptoAlm2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.limitCredit),
      expression: "contract.limitCredit"
    }, {
      name: "only-numbers",
      rawName: "v-only-numbers"
    }],
    staticClass: "inline form-control text-right col-md-2",
    attrs: {
      "minlength": "1",
      "maxlength": "2",
      "type": "text",
      "placeholder": "Digite o percentual",
      "disabled": !_vm.contract.lcFlag
    },
    domProps: {
      "value": (_vm.contract.limitCredit)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contract, "limitCredit", $event.target.value)
      }, function($event) {
        return _vm.setLimitValue($event.target.value)
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-detail-left"
  }, [_vm._v("Obs.: O percentual permitido é de 1% a 80%")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "id": "lc-confirma",
      "data-toggle": "tooltip",
      "title": "Confirma Alteração"
    },
    on: {
      "click": function($event) {
        return _vm.getUpdateAlert()
      }
    }
  }, [_vm._v("\n                        Confirma\n                      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 30) ? _c('div', [_c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Valor da Mensalidade:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.monthlyTax)))])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Taxa de Adesão:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.adhesionTax)))])]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Taxa de Substituição:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.replaceTax)))])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.invoice || _vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 8) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "info-box"
  }, [(_vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 8) ? _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Limite de crédito:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.creditLimit)))])]) : _vm._e(), _vm._v(" "), (_vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 8) ? _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Dia(s) de Vencimento:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.vencimentos()))])]) : _vm._e(), _vm._v(" "), (_vm.invoice) ? _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Fechamento da Fatura:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.invoice.endValidity)))])]) : _vm._e(), _vm._v(" "), (_vm.invoice) ? _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Vencimento da Fatura:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.invoice.expiration)))])]) : _vm._e(), _vm._v(" "), (_vm.invoice) ? _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Valor da Última Fatura:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.invoice.total)))])]) : _vm._e(), _vm._v(" "), (_vm.isGrouper === true) ? _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table stripped-odd no-footer desk",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.groupers), function(grouper) {
    return _c('tr', {
      key: grouper.idAgrupadorCliente
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(grouper.nome))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(grouper.descricao))]), _vm._v(" "), _c('td', {
      staticClass: "icons"
    }, [_c('img', {
      attrs: {
        "width": "16px",
        "src": require("../../../assets/img/icons/pen-icons.svg"),
        "alt": "Editar"
      },
      on: {
        "click": function($event) {
          return _vm.openEditModal(grouper.nome, grouper.descricao, grouper.idAgrupadorCliente)
        }
      }
    })])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isAddModalVisible) ? _c('div', [_c('div', {
    staticClass: "modal-backdrop fade show"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal show",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addGrouper.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "grouperName"
    }
  }, [_vm._v("Nome do Agrupador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGrouperName),
      expression: "newGrouperName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "grouperName",
      "required": ""
    },
    domProps: {
      "value": (_vm.newGrouperName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newGrouperName = $event.target.value
      }, function($event) {
        _vm.newGrouperName = _vm.mascaraApenasLetrasEAcentos(_vm.newGrouperName)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "grouperDescription"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGrouperDescription),
      expression: "newGrouperDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "grouperDescription",
      "required": ""
    },
    domProps: {
      "value": (_vm.newGrouperDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newGrouperDescription = $event.target.value
      }, function($event) {
        _vm.newGrouperDescription = _vm.mascaraApenasLetrasEAcentos(_vm.newGrouperDescription)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "padding": "0.5rem 0"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeAddModal
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Adicionar")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isEditModalVisible) ? _c('div', [_c('div', {
    staticClass: "modal-backdrop fade show"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal show",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitEdit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "editName"
    }
  }, [_vm._v("Nome do Agrupador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGrouperName),
      expression: "editGrouperName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "editName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editGrouperName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.editGrouperName = $event.target.value
      }, function($event) {
        _vm.editGrouperName = _vm.mascaraApenasLetrasEAcentos(_vm.editGrouperName)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "editDescription"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGrouperDescription),
      expression: "editGrouperDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "editDescription",
      "required": ""
    },
    domProps: {
      "value": (_vm.editGrouperDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.editGrouperDescription = $event.target.value
      }, function($event) {
        _vm.editGrouperDescription = _vm.mascaraApenasLetrasEAcentos(_vm.editGrouperDescription)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "padding": "0.5rem 0"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isGrouper === true) ? _c('div', {
    staticClass: "add"
  }, [_c('img', {
    attrs: {
      "width": "20px",
      "src": require("../../../assets/img/icons/icon-add.svg"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openAddModal()
      }
    }
  }), _vm._v("Novo Agrupador\n                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "info-box"
  }, [(_vm.planHasRecharge(_vm.contract.plan.planId) && _vm.contract.plan.planId != 45) ? _c('p', [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Saldo:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.currentBalance)))]), _vm._v(" "), (_vm.contract.status.contractStatusId != 0) ? _c('router-link', {
    staticClass: "btn btn-success btn-sm recharge",
    class: {
      'disabled': !_vm.checkVehicle
    },
    attrs: {
      "to": {
        name: 'contract-recharge',
        params: {
          contractId: _vm.contractId,
          planId: _vm.contract.plan.planId
        }
      },
      "tag": "button",
      "data-toggle": "tooltip",
      "title": "Fazer uma recarga manual",
      "disabled": !_vm.checkVehicle || (_vm.contract.status.contractStatusId != 1 && _vm.contract.status.contractStatusId != 5)
    }
  }, [_vm._v("\n                        Recarregar\n                        "), _c('i', {
    staticClass: "icon-coin align-icon-right-white"
  })]) : _c('button', {
    staticClass: "btn btn-success btn-sm recharge",
    class: {
      'disabled': !_vm.checkVehicle
    },
    attrs: {
      "data-toggle": "tooltip",
      "title": "Fazer uma recarga manual",
      "disabled": !_vm.checkVehicle
    },
    on: {
      "click": function($event) {
        return _vm.showMessageContract()
      }
    }
  }, [_vm._v("\n                        Recarregar\n                        "), _c('i', {
    staticClass: "icon-coin align-icon-right-white"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.planHasAutRecharge(_vm.contract.plan.planId) && _vm.contract.plan.planId != 45) ? _c('p', {
    staticClass: "alt-value"
  }, [_c('label', {
    staticClass: "label-detail"
  }, [_vm._v("Rec. Automática")]), _vm._v(" "), (_vm.getRechargeAut) ? _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.getRechargeAut)))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-sm",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openModalRecharge(_vm.contract.contractId)
      }
    }
  }, [_vm._v("\n                        Alterar Valor\n                        "), _c('i', {
    staticClass: "icon-coin align-icon-right"
  })])]) : _vm._e()])])])])])])]), _vm._v(" "), (_vm.planId == 32 && _vm.modalRecharge[_vm.contract.contractId]) ? _c('modal-automatic', {
    attrs: {
      "contract": _vm.contract
    },
    on: {
      "closeModalRecharge": _vm.closeModalRecharge
    }
  }) : _vm._e(), _vm._v(" "), (_vm.planId != 32 && _vm.modalRecharge[_vm.contract.contractId]) ? _c('modal-recharge', {
    attrs: {
      "contract": _vm.contract
    },
    on: {
      "closeModalRecharge": _vm.closeModalRecharge
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "onoffswitch-label",
    attrs: {
      "for": "round-switch"
    }
  }, [_c('span', {
    staticClass: "onoffswitch-inner"
  }), _vm._v(" "), _c('span', {
    staticClass: "onoffswitch-switch"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Adicionar Agrupador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Editar Agrupador")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-3c217b3a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/contract/contract-detail.vue
// module id = 2105
// module chunks = 1